import React from "react";
import { useI18n } from "../i18n/LanguageProvider";
import "../styles/components/lang-switch.scss";

export default function LanguageToggle({ className = "" }) {
  const { lang, setLang } = useI18n();
  return (
    <button
      className={`lang-toggle ${className}`.trim()}
      onClick={() => {
        const next = lang === "fr" ? "en" : "fr";
        setLang(next);
        try { localStorage.setItem("lang", next); } catch {}
      }}
      aria-label="Switch language"
    >
      {lang === "fr" ? "English" : "Français"}
    </button>
  );
}
